import { useZeny } from './ZenyProvider';

// An unavailable count must never be mistaken for a healthy zero.
export default () => {
  const { urgent, error, updatedAt } = useZeny();
  return error || !updatedAt ? '?' : urgent.length;
};
